import React from 'react'
import { TurnToSnippet, updateSku } from 'store/components/product-reviews'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'
import { WriteReviewActionProps } from './WriteReviewAction.types'

const WriteReviewAction: React.FC<WriteReviewActionProps> = ({
  reservation,
  variant,
}) => {
  const handleWriteReview = () => {
    updateSku(reservation.regItem.turntoSku)
    window.TurnToCmd('reviewsList.writeReview')
  }

  return (
    <>
      <TurnToSnippet pageId="gift-tracker-review-submission" sku="" />
      <Button
        data-testid={`GiftDetails__GiftActions__WriteReview__${variant}`}
        size="md"
        variant={variant}
        onClick={handleWriteReview}
      >
        Write review
      </Button>
    </>
  )
}

export default WriteReviewAction
